<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :title="$lang('修改日志')"
    >
      <div class="dialog-content">
        <JmsTable
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @row-del="rowDel"
          @size-change="sizeChange"
          @selection-change="selectionChange"
          @current-change="currentChange"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@/mixins/mixin.js'
import JmsTable from '@/components/jms-widget/jms-table'
import { logList } from '@api/module/customer'

export default {
  name: 'WaybillLog',
  mixins: [mixin],
  components: {
    JmsTable,
  },
  data () {
    return {
      viewDialogVisible: false,
      isShowFirst: false,
      COM_HTTP: {
        reqList: logList,
      },
      waybillNo: '',
    }
  },
  computed: {
    listOpt () {
      return {
        border: true,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        index: false,
        fixHeight: 90,
        column: [
          {
            label: '修改时间',
            prop: 'created',
          },
          {
            label: '修改内容',
            prop: 'udContent',
          },
          {
            label: '修改前',
            prop: 'beforeWaybillInfo',
            formatter(row) {
              if (row.udContent === 'cod金额修改' || row.udContent === 'COD Amount Adjustment') {
                return row.beforeCodMoney
              } else {
                return row.beforeWaybillInfo
              }
            },
          },
          {
            label: '修改后',
            prop: 'afterWaybillInfo',
            formatter(row) {
              if (row.udContent === 'cod金额修改' || row.udContent === 'COD Amount Adjustment') {
                return row.afterCodMoney
              } else {
                return row.afterWaybillInfo
              }
            },
          },
          // {
          //   label: '修改金额',
          //   prop: 'afterCodMoney',
          //   formatter(row) {
          //     return row.afterCodMoney > 0 ? row.afterCodMoney : '0'
          //   },
          // },
          {
            label: '状态',
            prop: 'status',
          },
          {
            label: '原因',
            prop: 'reason',
          },
          {
            label: '操作账号',
            prop: 'updateName',
          },
          {
            label: '运单号',
            prop: 'waybillCode',
          },
        ],
      }
    },
  },
  created () {
  },
  methods: {
    showDialog (waybillNo) {
      if (waybillNo) {
        this.waybillNo = waybillNo
        this.searchFun(1)
      }
      this.viewDialogVisible = true
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    getParams () {
      return {
        pageSize: this.page.size,
        waybillNo: this.waybillNo,
      }
    },
  },
}
</script>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 700px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
